import React from 'react';
import {
  Box,
  Typography,
  Tooltip,
} from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';

const GradeScheduleView = ({ grade, schedules, subjects, teachers, rooms, timeSlots, currentDay, handleOpenModal, isEditor }) => {
  if (!grade || !currentDay || isNaN(currentDay.getTime())) {
    return null; // or a loading spinner
  }

  const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  
  // Get Monday of the current week
  const monday = new Date(currentDay);
  while (monday.getDay() !== 1) {
    monday.setDate(monday.getDate() - 1);
  }
  monday.setHours(0, 0, 0, 0);
  
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const weekDateStrings = weekDays.map((_, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    
    const year = day.getFullYear();
    const month = String(day.getMonth() + 1).padStart(2, '0');
    const date = String(day.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${date}`;
  });

  const gradeSchedules = schedules.filter(event => 
    event.grade === grade && weekDateStrings.includes(event.day)
  );

  const darkGrayCellStyle = { border: '2px solid #000000', padding: '8px', textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#e0e0e0', height: '50px' };

  return (
    <Box id="grade-schedule-table">
      <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed', minWidth: '1800px' }}>
        <thead>
          <tr>
            <th style={{...darkGrayCellStyle, width: '120px'}}>Time</th>
            {weekDays.map((day, index) => (
              <th key={day} style={{...darkGrayCellStyle, textAlign: 'center'}}>
                {day}<br/>{formatDate(new Date(weekDateStrings[index] + 'T12:00:00'))}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map(timeSlot => {
            const isSpecialRow = ['snack', 'lunch', 10].includes(timeSlot.id);
            const rowStyle = { backgroundColor: isSpecialRow ? '#e0e0e0' : 'inherit' };
            return (
              <tr key={timeSlot.id}>
                <td style={{...darkGrayCellStyle, ...rowStyle}}>{timeSlot.time}</td>
                {weekDateStrings.map(dayString => {
                  const events = gradeSchedules.filter(e => e.day === dayString && e.timeSlotId === timeSlot.id);
                  
                  let cellContent = null;
                  if (events.length > 0) {
                    cellContent = (
                      <Box sx={{ display: 'flex', gap: '4px', width: '100%', height: '100%' }}>
                        {events.map(event => {
                          const subject = event.customSubject ? { name: event.customSubject } : subjects.find(s => s._id === event.subjectId);
                          const teacher = event.customTeacher ? { name: event.customTeacher } : teachers.find(t => t._id === event.teacherId);
                          const room = event.customRoom ? { name: event.customRoom } : rooms.find(r => r._id === event.roomId);
                          const eventColor = event.color || (subject && subject.color ? subject.color : '#808080');
                          return (
                            <Box key={event._id} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', flex: 1, backgroundColor: eventColor, color: 'white', padding: '4px 8px', paddingRight: event.isOnline ? '22px' : '8px', borderRadius: '4px', fontSize: '0.8rem', cursor: isEditor ? 'pointer' : 'default', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left' }} onClick={() => handleOpenModal(event)}>
                              <Typography variant="body1"><b>{subject ? `${subject.name} (${teacher ? teacher.name : 'N/A'})` : `Event (${teacher ? teacher.name : 'N/A'})`}</b></Typography>
                              <Typography variant="body2">{room ? room.name : 'N/A'}</Typography>
                              {event.isExam && (
                                  <Box sx={{ mt: 'auto', alignSelf: 'flex-start', padding: '0 4px', height: 18, borderRadius: '4px', bgcolor: '#e60000', border: '1.5px solid #ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <Typography sx={{ fontSize: '0.6rem', fontWeight: 900, color: '#ffffff', letterSpacing: '0.5px', lineHeight: 1 }}>EXAM</Typography>
                                  </Box>
                              )}
                              {event.isOnline && (
                                <Tooltip title="Online Lesson">
                                  <Box sx={{ position: 'absolute', bottom: 4, right: 4, width: 18, height: 18, borderRadius: '50%', bgcolor: 'rgba(0,0,0,0.28)', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                                    <WifiIcon sx={{ fontSize: '0.75rem', color: '#ffffff' }} />
                                  </Box>
                                </Tooltip>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  } else {
                    if (timeSlot.id === 'snack') { cellContent = <Typography variant="body1" sx={{fontWeight: 'bold', color: 'black', textAlign: 'center'}}>Snack</Typography>; }
                    else if (timeSlot.id === 'lunch') { cellContent = <Typography variant="body1" sx={{fontWeight: 'bold', color: 'black', textAlign: 'center'}}>Lunchbreak</Typography>; }
                    else if (timeSlot.id === 10) { cellContent = <Typography variant="body1" sx={{fontWeight: 'bold', color: 'black', textAlign: 'center'}}>Homework Time</Typography>; }
                  }

                  return (
                    <td key={`${dayString}-${timeSlot.id}`} style={{...darkGrayCellStyle, ...rowStyle}}>
                      {cellContent}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};

export default GradeScheduleView;
